import { render } from "./OttoFooter.vue?vue&type=template&id=dabbc208&scoped=true&ts=true"
import script from "./OttoFooter.vue?vue&type=script&lang=ts"
export * from "./OttoFooter.vue?vue&type=script&lang=ts"

import "./OttoFooter.vue?vue&type=style&index=0&id=dabbc208&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabbc208"]])

export default __exports__